/* Compact Spin LP — shared behaviour (reveal, counters, hero motion, sticky, parallax) */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(scope) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.18 });
    scope.querySelectorAll('.lp-rv, .lp-foldbar').forEach(function (el) {
      if (!el.classList.contains('in')) io.observe(el);
    });
  }

  function initCounters(scope) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        var el = e.target, target = parseFloat(el.dataset.count), dec = parseInt(el.dataset.dec || '0', 10);
        if (reduced) { el.textContent = target.toFixed(dec); return; }
        var t0 = null;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / 1400, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(dec);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    scope.querySelectorAll('[data-count]').forEach(function (el) { cio.observe(el); });
  }

  var scrollBound = false;
  function bindScroll() {
    if (scrollBound) return;
    scrollBound = true;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var hero = document.querySelector('.lp-hero');
        if (hero && !reduced) {
          var chair = hero.querySelector('.lp-chair--free') || hero.querySelector('.lp-frame img');
          if (chair) {
            var hh = hero.offsetHeight || 1;
            var prog = Math.min(Math.max(window.scrollY / hh, 0), 1.4);
            if (chair.classList.contains('lp-chair--free')) {
              chair.style.transform = 'rotate(' + (prog * 360) + 'deg) scale(' + (1 - prog * 0.12) + ')';
            } else {
              chair.style.transform = 'scale(' + (1 + prog * 0.1) + ') translateY(' + (prog * -24) + 'px) rotate(' + (prog * 4) + 'deg)';
            }
          }
        }
        var para = document.querySelector('.lp-close__bg');
        if (para && !reduced) {
          var r = para.parentElement.getBoundingClientRect();
          var vh = window.innerHeight;
          if (r.top < vh && r.bottom > 0) {
            var p = (vh - r.top) / (vh + r.height);
            para.style.transform = 'translateY(' + ((p - 0.5) * 60) + 'px)';
          }
        }
        var sticky = document.querySelector('.lp-sticky');
        if (sticky && hero) {
          var past = window.scrollY > (hero.offsetTop + hero.offsetHeight * 0.9);
          var shopSec = document.querySelector('.lp-shop');
          var inShop = false;
          if (shopSec) {
            var sr = shopSec.getBoundingClientRect();
            inShop = sr.top < window.innerHeight * 0.7 && sr.bottom > 0;
          }
          sticky.classList.toggle('on', past && !inShop);
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function openCartDrawer() {
    var d = document.querySelector('#cart-drawer, cart-drawer, [data-cart-drawer]');
    if (d) {
      if (typeof d.show === 'function') { try { d.show(); return; } catch (e) {} }
      d.setAttribute('open', '');
      d.classList.add('active', 'is-open', 'animate');
      d.style.visibility = 'visible';
    } else {
      var icon = document.querySelector('[data-cart-icon], #cart-icon-bubble, .header__icon--cart, a[href="/cart"]');
      if (icon) icon.click();
    }
  }

  function syncCartCount(freshDrawer) {
    var src = freshDrawer.querySelector('cart-count, .count-bubble');
    if (!src) return;
    var val = (src.textContent || '').trim();
    document.querySelectorAll('cart-count, .count-bubble, [data-cart-count]').forEach(function (el) {
      if (el.closest('#cart-drawer')) return;
      el.textContent = val;
    });
  }

  function paintDrawer(html) {
    if (!html) return false;
    var cur = document.querySelector('#cart-drawer, cart-drawer');
    if (!cur) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#cart-drawer, cart-drawer');
    if (!fresh) return false;
    cur.innerHTML = fresh.innerHTML;
    syncCartCount(fresh);
    return true;
  }

  function refreshDrawerFallback() {
    fetch('/?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) { paintDrawer(html); })
      .catch(function () {});
  }

  function addToCartAjax(form) {
    var btn = form.querySelector('[type="submit"]');
    var idEl = form.querySelector('[name="id"]');
    if (!idEl || !idEl.value) { form.submit(); return; }
    var restore = btn ? btn.textContent : '';
    var settled = false;
    function done() { if (settled) return; settled = true; if (btn) { btn.disabled = false; btn.textContent = restore; } }
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
    var watchdog = setTimeout(done, 8000); // never leave the button stuck
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (data) {
        clearTimeout(watchdog); done();
        var painted = false;
        try { painted = data && data.sections && paintDrawer(data.sections['cart-drawer']); } catch (e) {}
        openCartDrawer();
        if (!painted) refreshDrawerFallback();
      })
      .catch(function () {
        clearTimeout(watchdog); done();
        openCartDrawer(); refreshDrawerFallback();
      });
  }

  var atcBound = false;
  function initAtc() {
    if (atcBound) return;
    atcBound = true;
    // Delegated: catch every add-to-cart form on the LP (hero + shop cards), leave the theme's own forms alone
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.nodeName !== 'FORM') return;
      if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      if (form.hasAttribute('is')) return;
      if (!form.closest('[class*="lp-"]')) return;
      e.preventDefault();
      addToCartAjax(form);
    }, true);
  }

  function initAll(scope) {
    initReveals(scope || document);
    initCounters(scope || document);
    bindScroll();
    initAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
